import { Badge, useMantineTheme } from "@mantine/core";

import { Advisory_Severity } from "@protos/sca/v1/sca";

export interface SeverityBadgeProps {
  severity: Advisory_Severity | undefined;
}

export const SeverityBadge = ({ severity }: SeverityBadgeProps) => {
  const { colors } = useMantineTheme();
  switch (severity) {
    case Advisory_Severity.CRITICAL:
      return (
        <Badge
          variant="filled"
          color="red.8"
          size="xs"
          style={{ pointerEvents: "none" }}
        >
          critical
        </Badge>
      );
    case Advisory_Severity.HIGH:
      return (
        <Badge
          variant="filled"
          color="red.0"
          size="xs"
          style={{
            color: colors["red"][8],
            border: "1px solid ",
            borderColor: colors["red"][8],
            pointerEvents: "none",
          }}
        >
          high
        </Badge>
      );
    case Advisory_Severity.MEDIUM:
      return (
        <Badge
          variant="filled"
          color="orange.6"
          size="xs"
          style={{ pointerEvents: "none" }}
        >
          medium
        </Badge>
      );
    case Advisory_Severity.LOW:
      return (
        <Badge
          variant="filled"
          color="cyan.5"
          size="xs"
          style={{ pointerEvents: "none" }}
        >
          low
        </Badge>
      );
    default:
      return null;
  }
};
